import { useAuth } from 'hooks';
import { DefaultUser, SupplierDefaultValues } from 'types';
import styles from './OrganizationDefaults.module.scss';
import { OrganizationDefaultUsers } from './OrganizationDefaultUsers/OrganizationDefaultUsers';
import { OrganizationDefaultValues } from './OrganizationDefaultValues/OrganizationDefaultValues';
import { getSupplierDefaultValues } from 'lib/firebase';
import { useEffect, useState } from 'react';
import { getDefaultUsers } from 'store/services/supplier';

export interface OrganizationDefaultsProps {
    /** A supplierId for the supplier that an admin user wants to view data for. */
    viewAsSupplier?: string;
}

export const OrganizationDefaults = ({
    viewAsSupplier,
}: OrganizationDefaultsProps) => {
    const { user } = useAuth();
    const [supplierDefaultValues, setSupplierDefaultValues] =
        useState<SupplierDefaultValues>();
    const [supplierDefaultUsers, setSupplierDefaultUsers] = useState<
        DefaultUser[]
    >([]);

    useEffect(() => {
        if (!!user?.protected?.supplierId?.toString()) {
            getSupplierDefaultValues(
                viewAsSupplier ?? user.protected.supplierId
            ).then((data) => {
                if (data) setSupplierDefaultValues(data);
            });

            getDefaultUsers(viewAsSupplier ?? user.protected.supplierId).then(
                (data) => {
                    if (data) setSupplierDefaultUsers(data);
                }
            );
        }
    }, [user, viewAsSupplier]);

    return (
        <div
            data-testid="OrganizationDefaults"
            className={styles.OrganizationDefaults}
        >
            {supplierDefaultValues && (
                <div className={styles.cardCol}>
                    <OrganizationDefaultValues
                        supplierDefaultValues={supplierDefaultValues}
                        supplierId={
                            viewAsSupplier ?? user?.protected?.supplierId ?? ''
                        }
                    />
                </div>
            )}
            <div className={styles.cardCol + ' ' + styles.table}>
                <OrganizationDefaultUsers
                    supplierId={
                        viewAsSupplier ?? user?.protected?.supplierId ?? ''
                    }
                    supplierDefaultUsers={supplierDefaultUsers}
                    updateDefaultUsers={setSupplierDefaultUsers}
                />
            </div>
        </div>
    );
};
